import React from 'react';
import { WifiOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../../../layout/AppHeader';

interface SessionFetchErrorProps {
  onRetry: () => void;
}

const SessionFetchError: React.FC<SessionFetchErrorProps> = ({ onRetry }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-screen bg-[#FFF8F0]">
      <AppHeader />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center p-8 max-w-md">
          <WifiOff className="w-16 h-16 mx-auto text-orange-400 mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Unable to Load Session</h1>
          <p className="text-xs text-gray-500 mb-6">
            We couldn't connect to this session. Please verify that the invite link is correct and
            that the session host has started the meeting. If the problem persists, try again or
            return to the dashboard.
          </p>
          <div className="flex gap-3 justify-center">
            <button
              onClick={onRetry}
              className="px-4 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-medium transition-all duration-300 text-sm shadow-sm"
            >
              Try Again
            </button>
            <button
              onClick={() => navigate('/dashboard')}
              className="px-4 py-2.5 bg-white border border-gray-200 hover:border-gray-300 text-gray-700 rounded-xl font-medium transition-all duration-300 text-sm"
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SessionFetchError;
